import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBYbhMRmMQOjrQ3x1vMmD0VfD1dj3wc3_I",
  authDomain: "boop-yachts.firebaseapp.com",
  projectId: "boop-yachts",
  storageBucket: "boop-yachts.firebasestorage.app",
  messagingSenderId: "105570157451",
  appId: "1:105570157451:web:97713b591b57d158e3a58e",
  measurementId: "G-2XLKDTG007"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage, app };
